export function initAniLightflow(){
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const els = document.querySelectorAll('.ani-lightflow');
  els.forEach(el => {
    if (el.dataset.aniLightflowBound) return;
    el.dataset.aniLightflowBound = '1';
    const scope = el.closest('.ani-hover-scope')
      || el.closest('.colorcina-card-container')
      || el;

    let rect = el.getBoundingClientRect();
    const updateRect = () => { rect = el.getBoundingClientRect(); };
    const onMove = (e) => {
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      el.style.setProperty('--mx', x + 'px');
      el.style.setProperty('--my', y + 'px');
    };
    scope.addEventListener('pointerenter', updateRect, { passive: true });
    scope.addEventListener('pointermove', onMove, { passive: true });
  });
}

export function initAniLightbulb(){
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const els = document.querySelectorAll('.ani-lightbulb');
  els.forEach(el => {
    if (el.dataset.aniLightbulbBound) return;
    el.dataset.aniLightbulbBound = '1';
    const scope = el.closest('.ani-hover-scope')
      || el.closest('.colorcina-card-container')
      || el;

    let rect = el.getBoundingClientRect();
    let contentRect = null;
    const card = el.closest('.colorcina-card-container');
    const content = card?.querySelector('.colorcina-card-content') || null;

    const updateRect = () => {
      rect = el.getBoundingClientRect();
      if (content) contentRect = content.getBoundingClientRect();
    };
    const onMove = (e) => {
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      el.style.setProperty('--mx', x + 'px');
      el.style.setProperty('--my', y + 'px');
      if (contentRect) {
        const inside = e.clientX >= contentRect.left && e.clientX <= contentRect.right &&
                       e.clientY >= contentRect.top  && e.clientY <= contentRect.bottom;
        
        
        el.style.setProperty('--ani-light-opacity', inside ? '0.5' : '0.8');
      }
    };
    scope.addEventListener('pointerenter', updateRect, { passive: true });
    scope.addEventListener('pointermove', onMove, { passive: true });
  });
}
